import {Qualtrics_Identifier} from '../config';

const QUALTRICS_NAMESPACE = 'auroraQualtricsData';
const QUALTRICS_ID = Qualtrics_Identifier;

export const setQualtricsData = (key: string, value: string | number) => {
  if (!QUALTRICS_ID || typeof window === 'undefined') return;
  (window as any)[QUALTRICS_NAMESPACE] =
    (window as any)[QUALTRICS_NAMESPACE] || {};
  (window as any)[QUALTRICS_NAMESPACE][key] = value;
};

export const setQualtricsDataMultiple = (
  data: Record<string, string | number>
) => {
  Object.entries(data).forEach(([key, value]) => {
    setQualtricsData(key, value);
  });
};

/**
 * Resets all Qualtrics embedded data by clearing the custom QUALTRICS_NAMESPACE.
 */
export const resetQualtricsData = () => {
  if (typeof window !== 'undefined') {
    (window as any)[QUALTRICS_NAMESPACE] = {};
  }
};
